import { bindFinishTourOnClick, unbindFinishTourOnClick } from '../../tourUi'

const FORM_READY_SELECTOR = '[data-tour="monitorado-form-root"][data-carregado="true"]'
const MODAL_SETTLE_MS = 350

const delay = (milliseconds) => new Promise((resolve) => setTimeout(resolve, milliseconds))

const clickTab = (selector) => {
    const tabElement = document.querySelector(selector)

    if (tabElement && !tabElement.classList.contains('react-tabs__tab--selected')) {
        tabElement.click()
    }
}

const clickTabAndMoveNext = (tourManager, tabSelector) => () => {
    clickTab(tabSelector)
    setTimeout(() => tourManager.moveNext(), 200)
}

const clickTabAndMovePrev = (tourManager, tabSelector) => () => {
    clickTab(tabSelector)
    setTimeout(() => tourManager.movePrevious(), 200)
}

const hasParametrosVinculados = () => {
    const root = document.querySelector('[data-tour="monitorado-form-root"]')
    return root?.getAttribute('data-tem-parametros') === 'true'
}

const hasTab = (selector) => Boolean(document.querySelector(selector))

const ensureDetalhesTab = () => {
    clickTab('[data-tour="tab-monitorado-detalhes"]')
    return delay(150)
}

const ensureTab = (selector) => () => {
    clickTab(selector)
    return delay(200)
}

const bindIrParaEquipamentoLink = () => {
    setTimeout(() => {
        const link = document.querySelector(
            '.driver-popover-description [data-hdv-ir-equipamento]'
        )

        if (!link || link._hdvIrEquipamentoBound) return

        link._hdvIrEquipamentoBound = true
        link.addEventListener('click', (event) => {
            event.preventDefault()
            event.stopPropagation()
            window.location.href = '/equipamento'
        })
    }, 0)
}

const bindIrParaListaLink = () => {
    setTimeout(() => {
        const link = document.querySelector(
            '.driver-popover-description [data-hdv-ir-lista-monitorados]'
        )

        if (!link || link._hdvIrListaBound) return

        link._hdvIrListaBound = true
        link.addEventListener('click', (event) => {
            event.preventDefault()
            event.stopPropagation()
            window.location.href = '/lista-monitorados'
        })
    }, 0)
}

const bindIrParaDashboardLink = () => {
    setTimeout(() => {
        const link = document.querySelector(
            '.driver-popover-description [data-hdv-ir-dashboard]'
        )

        if (!link || link._hdvIrDashboardBound) return

        link._hdvIrDashboardBound = true
        link.addEventListener('click', (event) => {
            event.preventDefault()
            event.stopPropagation()
            window.location.href = '/'
        })
    }, 0)
}

const fecharModalCondicao = async () => {
    document.querySelector('.modal.show .close')?.click()
    await delay(MODAL_SETTLE_MS)
}

const abrirModalCondicao = async (tourManager) => {
    clickTab('[data-tour="tab-monitorado-condicoes"]')
    await delay(150)

    if (!document.querySelector('[data-tour="monitorado-condicao-descricao"]')) {
        document.querySelector('[data-tour="monitorado-condicao-nova"]')?.click()
    }

    await tourManager.waitForElement('[data-tour="monitorado-condicao-descricao"]')
    await delay(MODAL_SETTLE_MS)
}

const ensureModalCondicaoAberto = (tourManager) => () => abrirModalCondicao(tourManager)

const buildCondicoesSteps = (tourManager) => {
    const steps = [
        {
            element: '[data-tour="tab-monitorado-condicoes"]',
            popover: {
                title: 'Aba Condições',
                description: 'Aqui você cria alertas visuais com base nos parâmetros vinculados. Clique em <strong>Próximo</strong> para abrir a aba.',
                side: 'bottom',
                align: 'start',
                onNextClick: clickTabAndMoveNext(tourManager, '[data-tour="tab-monitorado-condicoes"]'),
                onPrevClick: () => {
                    if (hasTab('[data-tour="tab-monitorado-parametros"]')) {
                        clickTabAndMovePrev(tourManager, '[data-tour="tab-monitorado-parametros"]')()
                        return
                    }

                    clickTabAndMovePrev(tourManager, '[data-tour="tab-monitorado-detalhes"]')()
                },
            },
        },
    ]

    if (!hasParametrosVinculados()) {
        steps.push({
            element: '[data-tour="monitorado-condicoes-root"]',
            ensureReady: ensureTab('[data-tour="tab-monitorado-condicoes"]'),
            popover: {
                title: 'Parâmetros necessários',
                description: 'Para cadastrar condições, vincule ao menos um parâmetro na aba Parâmetros. Caso ainda não tenha parametrizações, <a href="#" class="hdv-tour-start-link" data-hdv-ir-equipamento>clique aqui</a> para criar parâmetros em um equipamento.',
                side: 'top',
                align: 'start',
                onPrevClick: clickTabAndMovePrev(tourManager, '[data-tour="tab-monitorado-condicoes"]'),
            },
            onHighlighted: () => bindIrParaEquipamentoLink(),
        })

        return steps
    }

    steps.push(
        {
            element: '[data-tour="monitorado-condicao-nova"]',
            ensureReady: ensureTab('[data-tour="tab-monitorado-condicoes"]'),
            popover: {
                title: 'Nova condição',
                description: 'Use este botão para criar um alerta. Clique em <strong>Próximo</strong> para abrir o formulário.',
                side: 'bottom',
                align: 'start',
                onNextClick: () => {
                    abrirModalCondicao(tourManager)
                        .then(() => tourManager.moveNext())
                        .catch(() => tourManager.moveNext())
                },
                onPrevClick: clickTabAndMovePrev(tourManager, '[data-tour="tab-monitorado-condicoes"]'),
            },
        },
        {
            element: '[data-tour="monitorado-condicao-descricao"]',
            ensureReady: ensureModalCondicaoAberto(tourManager),
            popover: {
                title: 'Descrição da condição',
                description: 'Dê um nome ao alerta, por exemplo “Nível alto” ou “Falha de comunicação”.',
                side: 'bottom',
                align: 'start',
                onPrevClick: () => {
                    fecharModalCondicao().then(() => tourManager.movePrevious())
                },
            },
        },
        {
            element: '[data-tour="monitorado-condicao-cor"]',
            ensureReady: ensureModalCondicaoAberto(tourManager),
            popover: {
                title: 'Cor do alerta',
                description: 'Escolha a cor que representa esta condição nas telas de monitoramento.',
                side: 'bottom',
                align: 'start',
                onPrevClick: () => tourManager.movePrevious(),
            },
        },
        {
            element: '[data-tour="monitorado-condicao-nova-regra"]',
            ensureReady: ensureModalCondicaoAberto(tourManager),
            popover: {
                title: 'Regras da condição',
                description: 'Clique em <strong>Nova condição</strong> para adicionar uma regra: escolha o parâmetro, o comparador (maior, menor e igual) e o valor. Você pode combinar várias regras com “E”.',
                side: 'top',
                align: 'start',
                onPrevClick: () => tourManager.movePrevious(),
            },
            onHighlighted: (element) => {
                element?.addEventListener('click', () => tourManager.minimize(), { once: true })
            },
        },
        {
            element: '[data-tour="monitorado-condicao-acoes"]',
            ensureReady: ensureModalCondicaoAberto(tourManager),
            popover: {
                title: 'Salvar condição',
                description: 'Depois de montar as regras, use <strong>Adicionar</strong> para salvar. <strong>Cancelar</strong> fecha sem gravar.',
                side: 'left',
                align: 'start',
                onNextClick: () => {
                    fecharModalCondicao().then(() => tourManager.moveNext())
                },
                onPrevClick: () => tourManager.movePrevious(),
            },
        },
        {
            element: () =>
                document.querySelector('[data-tour="monitorado-condicao-lista"]') ||
                document.querySelector('[data-tour="monitorado-condicao-lista-vazia"]'),
            ensureReady: ensureTab('[data-tour="tab-monitorado-condicoes"]'),
            popover: {
                title: 'Lista de condições',
                description: 'As condições cadastradas aparecem aqui. Você pode editar ou remover quando precisar.',
                side: 'top',
                align: 'start',
                onPrevClick: () => {
                    abrirModalCondicao(tourManager)
                        .then(() => tourManager.movePrevious())
                        .catch(() => tourManager.movePrevious())
                },
            },
        }
    )

    return steps
}

const buildParametrosSteps = (tourManager) => {
    if (!hasTab('[data-tour="tab-monitorado-parametros"]')) return []

    return [
        {
            element: '[data-tour="tab-monitorado-parametros"]',
            popover: {
                title: 'Aba Parâmetros',
                description: 'Aqui você vincula os parâmetros do equipamento a este monitorado. É o que permite ver dados, gráficos e alertas. Clique em <strong>Próximo</strong> para abrir a aba.',
                side: 'bottom',
                align: 'start',
                onNextClick: clickTabAndMoveNext(tourManager, '[data-tour="tab-monitorado-parametros"]'),
                onPrevClick: clickTabAndMovePrev(tourManager, '[data-tour="tab-monitorado-detalhes"]'),
            },
        },
        {
            element: '[data-tour="monitorado-param-equipamento"]',
            ensureReady: ensureTab('[data-tour="tab-monitorado-parametros"]'),
            popover: {
                title: 'Equipamento',
                description: 'Escolha o equipamento de onde virão os dados. Caso ainda não tenha parametrizações feitas, <a href="#" class="hdv-tour-start-link" data-hdv-ir-equipamento>clique aqui</a>.',
                side: 'bottom',
                align: 'start',
                onPrevClick: clickTabAndMovePrev(tourManager, '[data-tour="tab-monitorado-parametros"]'),
            },
            onHighlighted: () => bindIrParaEquipamentoLink(),
        },
        {
            element: '[data-tour="monitorado-param-campo"]',
            ensureReady: ensureTab('[data-tour="tab-monitorado-parametros"]'),
            popover: {
                title: 'Parâmetro',
                description: 'Depois de escolher o equipamento, selecione o parâmetro que deseja acompanhar neste monitorado.',
                side: 'bottom',
                align: 'start',
                onPrevClick: () => tourManager.movePrevious(),
            },
        },
        {
            element: '[data-tour="monitorado-param-vincular"]',
            ensureReady: ensureTab('[data-tour="tab-monitorado-parametros"]'),
            popover: {
                title: 'Vincular parâmetro',
                description: 'Clique para associar o parâmetro ao monitorado. A vinculação é salva na hora. Ao clicar, o guia é minimizado.',
                side: 'left',
                align: 'start',
                onPrevClick: () => tourManager.movePrevious(),
            },
            onHighlighted: (element) => {
                element?.addEventListener('click', () => tourManager.minimize(), { once: true })
            },
        },
        {
            element: () =>
                document.querySelector('[data-tour="monitorado-param-lista"]') ||
                document.querySelector('[data-tour="monitorado-param-lista-vazia"]'),
            ensureReady: ensureTab('[data-tour="tab-monitorado-parametros"]'),
            popover: {
                title: 'Parâmetros vinculados',
                description: 'A lista mostra tudo o que já está vinculado. Com parâmetros aqui, o monitorado passa a exibir dados na Lista de Monitorados.',
                side: 'top',
                align: 'start',
                onPrevClick: () => tourManager.movePrevious(),
            },
        },
    ]
}

const buildComandosSteps = (tourManager) => {
    if (!hasTab('[data-tour="tab-monitorado-comandos"]')) return []

    return [
        {
            element: '[data-tour="tab-monitorado-comandos"]',
            popover: {
                title: 'Aba Comandos',
                description: 'Aqui você vincula comandos do equipamento para usá-los neste monitorado (por exemplo em automações). Clique em <strong>Próximo</strong> para abrir a aba.',
                side: 'bottom',
                align: 'start',
                onNextClick: clickTabAndMoveNext(tourManager, '[data-tour="tab-monitorado-comandos"]'),
                onPrevClick: clickTabAndMovePrev(tourManager, '[data-tour="tab-monitorado-condicoes"]'),
            },
        },
        {
            element: '[data-tour="monitorado-cmd-equipamento"]',
            ensureReady: ensureTab('[data-tour="tab-monitorado-comandos"]'),
            popover: {
                title: 'Equipamento',
                description: 'Selecione o equipamento que possui o comando. Caso ainda não tenha comandos cadastrados, <a href="#" class="hdv-tour-start-link" data-hdv-ir-equipamento>clique aqui</a>.',
                side: 'bottom',
                align: 'start',
                onPrevClick: clickTabAndMovePrev(tourManager, '[data-tour="tab-monitorado-comandos"]'),
            },
            onHighlighted: () => bindIrParaEquipamentoLink(),
        },
        {
            element: '[data-tour="monitorado-cmd-campo"]',
            ensureReady: ensureTab('[data-tour="tab-monitorado-comandos"]'),
            popover: {
                title: 'Comando',
                description: 'Escolha o comando que deseja vincular a este monitorado.',
                side: 'bottom',
                align: 'start',
                onPrevClick: () => tourManager.movePrevious(),
            },
        },
        {
            element: '[data-tour="monitorado-cmd-vincular"]',
            ensureReady: ensureTab('[data-tour="tab-monitorado-comandos"]'),
            popover: {
                title: 'Vincular comando',
                description: 'Associe o comando ao monitorado. A vinculação é salva imediatamente. Ao clicar, o guia é minimizado.',
                side: 'left',
                align: 'start',
                onPrevClick: () => tourManager.movePrevious(),
            },
            onHighlighted: (element) => {
                element?.addEventListener('click', () => tourManager.minimize(), { once: true })
            },
        },
        {
            element: () =>
                document.querySelector('[data-tour="monitorado-cmd-lista"]') ||
                document.querySelector('[data-tour="monitorado-cmd-lista-vazia"]'),
            ensureReady: ensureTab('[data-tour="tab-monitorado-comandos"]'),
            popover: {
                title: 'Comandos vinculados',
                description: 'Aqui ficam os comandos já associados a este monitorado.',
                side: 'top',
                align: 'start',
                onPrevClick: () => tourManager.movePrevious(),
            },
        },
    ]
}

const buildFotosSteps = (tourManager) => [
    {
        element: '[data-tour="tab-monitorado-fotos"]',
        popover: {
            title: 'Aba Fotos',
            description: 'Nesta aba você anexa fotos do local ou do ponto monitorado. Clique em <strong>Próximo</strong> para abrir.',
            side: 'bottom',
            align: 'start',
            onNextClick: clickTabAndMoveNext(tourManager, '[data-tour="tab-monitorado-fotos"]'),
            onPrevClick: () => {
                if (hasTab('[data-tour="tab-monitorado-comandos"]')) {
                    clickTabAndMovePrev(tourManager, '[data-tour="tab-monitorado-comandos"]')()
                    return
                }

                clickTabAndMovePrev(tourManager, '[data-tour="tab-monitorado-condicoes"]')()
            },
        },
    },
    {
        element: '[data-tour="monitorado-foto-arquivo"]',
        ensureReady: ensureTab('[data-tour="tab-monitorado-fotos"]'),
        popover: {
            title: 'Selecionar foto',
            description: 'Escolha um arquivo de imagem (JPG, PNG ou WEBP).',
            side: 'bottom',
            align: 'start',
            onPrevClick: clickTabAndMovePrev(tourManager, '[data-tour="tab-monitorado-fotos"]'),
        },
    },
    {
        element: '[data-tour="monitorado-foto-descricao"]',
        ensureReady: ensureTab('[data-tour="tab-monitorado-fotos"]'),
        popover: {
            title: 'Descrição',
            description: 'Informe uma descrição curta para identificar a foto.',
            side: 'bottom',
            align: 'start',
            onPrevClick: () => tourManager.movePrevious(),
        },
    },
    {
        element: '[data-tour="monitorado-foto-adicionar"]',
        ensureReady: ensureTab('[data-tour="tab-monitorado-fotos"]'),
        popover: {
            title: 'Adicionar foto',
            description: 'Com o arquivo e a descrição preenchidos, clique para incluir a foto na lista.',
            side: 'left',
            align: 'start',
            onPrevClick: () => tourManager.movePrevious(),
        },
        onHighlighted: (element) => {
            element?.addEventListener('click', () => tourManager.minimize(), { once: true })
        },
    },
]

const buildEditarMonitoradoTourSteps = (tourManager) => {
    const steps = [
        {
            ensureReady: () =>
                tourManager.waitForElement(FORM_READY_SELECTOR).then(() => ensureDetalhesTab()),
            onHighlighted: () => ensureDetalhesTab(),
            popover: {
                title: 'Monitorado cadastrado',
                description: 'Este monitorado já foi salvo. Agora você pode vincular parâmetros e comandos, criar condições de alerta e adicionar fotos.',
            },
        },
        {
            element: '[data-tour="tab-monitorado-detalhes"]',
            ensureReady: ensureDetalhesTab,
            popover: {
                title: 'Aba Detalhes',
                description: 'Aqui ficam nome, cliente, tipo e localização. Você pode alterar esses dados e salvar novamente quando precisar.',
                side: 'bottom',
                align: 'start',
                onNextClick: () => {
                    clickTab('[data-tour="tab-monitorado-detalhes"]')
                    setTimeout(() => tourManager.moveNext(), 200)
                },
                onPrevClick: () => tourManager.movePrevious(),
            },
        },
        ...buildParametrosSteps(tourManager),
        ...buildCondicoesSteps(tourManager),
        ...buildComandosSteps(tourManager),
        ...buildFotosSteps(tourManager),
        {
            element: '[data-tour="menu-lista-monitorados"]',
            popover: {
                title: 'Lista de Monitorados',
                description: 'Ao concluir o cadastro e o vínculo dos parâmetros, acesse a <a href="#" class="hdv-tour-start-link" data-hdv-ir-lista-monitorados>Lista de Monitorados</a> para acompanhar gráficos, alertas e comandos. Essas informações também serão exibidas na <a href="#" class="hdv-tour-start-link" data-hdv-ir-dashboard>Dashboard</a>.',
                side: 'right',
                align: 'start',
                onPrevClick: clickTabAndMovePrev(tourManager, '[data-tour="tab-monitorado-fotos"]'),
            },
            onHighlighted: () => {
                bindIrParaListaLink()
                bindIrParaDashboardLink()
            },
        },
        {
            element: '[data-tour="monitorado-salvar"]',
            popover: {
                title: 'Salvar alterações',
                description: 'Se houver alterações nos detalhes, salve aqui. Os vínculos de parâmetros e comandos já são gravados ao clicar em Vincular.',
                side: 'top',
                align: 'start',
                onPrevClick: () => tourManager.movePrevious(),
            },
            onHighlighted: (element) => {
                bindFinishTourOnClick(element, tourManager, 'editar-monitorado')
            },
            onDeselected: (element) => {
                unbindFinishTourOnClick(element)
            },
        },
        {
            popover: {
                title: 'Tudo pronto!',
                description: 'Você já conhece as abas deste monitorado. Quando quiser, use a Lista de Monitorados para acompanhar as comunicações e os dados vinculados.',
                onPrevClick: () => tourManager.movePrevious(),
            },
        },
    ]

    return steps
}

export default buildEditarMonitoradoTourSteps
